import { useLayoutEffect, useState } from "react";

/** `leading-6` (24px) × 3 lines + description panel vertical padding. */
export const COMPACT_VIDEO_DESCRIPTION_MAX_HEIGHT_PX = 108;

/**
 * True when description fits in ~1–3 lines: center the player stack like the
 * no-description overlay. Longer copy uses the top-aligned scrollable layout.
 */
export function useCompactVideoDescriptionLayout(
  descriptionElement: HTMLElement | null,
  enabled: boolean
): boolean {
  const [isCompact, setIsCompact] = useState(true);

  useLayoutEffect(() => {
    if (!enabled || !descriptionElement) {
      setIsCompact(true);
      return;
    }

    const measure = () => {
      setIsCompact(
        descriptionElement.scrollHeight <=
          COMPACT_VIDEO_DESCRIPTION_MAX_HEIGHT_PX
      );
    };

    measure();

    const observer = new ResizeObserver(measure);
    observer.observe(descriptionElement);

    return () => observer.disconnect();
  }, [descriptionElement, enabled]);

  return isCompact;
}
